import { NotificationMessages } from '../types';

export const notificationZHTW: NotificationMessages = {
    'app.notification.title': '通知中心',
    "app.notification.generate_file": "我們正在生成您的檔案。檔案準備好後，您將收到下載通知。",
    'app.notification.download_program': '下載程式詳細資訊',
};
